import React from 'react';
import parse from 'html-react-parser';
import { motion } from 'framer-motion';

export default function FitnessBookingDesktop({ dswBookingCalendarList }) {
  return (
    <motion.table
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: 0.6 }}
      viewport={{ once: true }}
      className="border-spacing-y-[8px] 3xl:border-spacing-x-[30px] lg2:border-spacing-[15px]
      border-spacing-[10px]
      border-separate 3xl:-ml-[30px] -ml-[15px] lg:block hidden overflow-x-auto
      2xl:overflow-x-hidden">
      <thead>
        <tr>
          {dswBookingCalendarList.map((day, index) => (
            <th
              key={index}
              className="font-roboto-bold 2xl:text-[18px] lg2:text-[16px] text-[14px] leading-5
            text-left 2xl:pb-[27px] lg2:pb-4 pb-[5px] text-primary">
              {day.content.fitnessDay}
            </th>
          ))}
          <th />
        </tr>
      </thead>
      <tbody>
        {dswBookingCalendarList[0].content.dSWCalendarItems.map((item, index) => {
          const hoursSplit = item.content.fitnessHours.split('|');
          return (
            <tr key={index}>
              {dswBookingCalendarList.map((day) => {
                const fitnessItem = day.content.dSWCalendarItems.find(
                  (i) => i.content.fitnessHours === item.content.fitnessHours,
                );
                return (
                  <td
                    key={day.content.fitnessDay}
                    className={`2xl:min-w-[119px] min-w-[80px] h-[67px] font-roboto-bold
                  2xl:text-[13px] lg2:text-[12px] text-[11px] leading-5 text-center
                  text-white px-[10px] uppercase
              ${
                fitnessItem?.content?.fitnessColor
                  ? `bg-[#${fitnessItem.content.fitnessColor}]`
                  : 'bg-bg-1'
              }`}>
                    {parse(fitnessItem?.content?.fitnessName || '')}
                  </td>
                );
              })}
              <td
                className="font-roboto-bold 3xl:text-[18px] 2xl:text-[15px] text-[13px]
              leading-5 text-center 2xl:w-[109px] w-[80px] 2xl:min-w-[109px] min-w-[80px]">
                {hoursSplit[0]} <p className="text-[13px]">{hoursSplit[1]}</p>
              </td>
            </tr>
          );
        })}
      </tbody>
    </motion.table>
  );
}
